// Mirrors INTERACTION_TYPES in src/api/filters.py — the canonical list.
// The backend rejects any type not on it.
export const INTERACTION_TYPES = [
  'visit',
  'phone_call',
  'attempted_phone_call',
  'text_message',
  'ministering_interview',
  'event_attendance',
  'sunday_chat',
  'ward_council',
  'welfare',
  'email',
  'other',
] as const;

export type InteractionType = (typeof INTERACTION_TYPES)[number];

export function formatInteractionType(t: string): string {
  return t.split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
